import Duration from "components/Atoms/Duration"
import Paper from "components/Atoms/Paper"
import SubHeader from "components/Organisms/SubHeader"
import dayjs from "dayjs"
import { useBeatDetailQuery } from "generated/graphql"
import BeatStatusIcon from "pages/fsm/BeatStatusIcon"
import React from "react"
import { useNavigate, useParams } from "react-router-dom"
import AddRemark from "./AddRemark"
import BeatTrackingMap from "./BeatTrackingMap"
import BeatTrackingTimeline from "./BeatTrackingTimeline"
import TrackInfo from "./TrackInfo"
import VisitDetails from "./VisitDetails"

// const remarks = [
//   {
//     title: "DCO Remark",
//     icon: "",
//     remark: "Completed beat",
//   },
//   {
//     title: "Admin Remark",
//     icon: "",
//     remark: "Completed beat from admin",
//   },
//   {
//     title: "Peasent Remark",
//     remark: `Lorem ipsum dolor sit, amet consectetur adipisicing elit. Minus, blanditiis eveniet earum quo sit ea et corporis laborum? Tempore laudantium assumenda quidem dolore. Quisquam nemo esse iusto ducimus tempore aspernatur eos cum deserunt iure, doloribus libero dolorum culpa, adipisci ipsam accusantium quia numquam, voluptatibus molestiae ad nesciunt nostrum voluptates veniam!`,
//   },
// ]
const BeatMonitoringDetails = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { data } = useBeatDetailQuery({ variables: { id } })

  if (!data) return null
  const beat = data.beatDetail
  const route = beat.assignment.route
  const outlets = beat.assignment.assignedRoutePoints
  const duration = beat.summary.durationAvg
  return (
    <SubHeader
      className="h-content"
      breadrumbs={[
        {
          href: "/d/fsm/monitor",
          text: "Monitor",
          onClick(e) {
            e.preventDefault()
            navigate("/d/fsm/monitor")
          },
        },
        {
          href: `/d/fsm/monitor/${id}`,
          text: route.name || id,
          onClick(e) {
            e.preventDefault()
            navigate(id)
          },
        },
      ]}
    >
      <Paper className="p-3 h-full flex gap-3 text-gray-700">
        <div className="w-3/12">
          <TrackInfo
            info={[
              {
                icon: "map-marker",
                title: beat.assignment.route.surveyArea.properties.name,
              },
              {
                icon: "group-objects",
                title: beat.assignee.fullName,
                subtitle: beat.assignee.number,
              },
              {
                icon: "target",
                title: route.name,
              },
              {
                icon: "circle",
                title: <BeatStatusIcon status={beat.status} />,
                // Wed 1st June 2022
                subtitle: dayjs(beat.date).format("dddd, Do MMMM YYYY"),
              },
              {
                icon: "time",
                title: (
                  <>
                    Avg. time spent: <Duration duration={duration} />
                  </>
                ),
              },
            ]}
          />
          {/* {remarks.map(remark => {
            return (
              <React.Fragment key={remark.title}>
                <Divider dashed />
                <CollapseCard
                  className="max-w-xs"
                  icon={<Icon icon="clipboard" />}
                  title={remark.title}
                >
                  <div className="p-2">{remark.remark}</div>
                </CollapseCard>
              </React.Fragment>
            )
          })} */}
        </div>
        <div className="w-3/12 overflow-auto">
          <BeatTrackingTimeline outlets={outlets} />
        </div>
        <div className="w-6/12">
          <div>
            <BeatTrackingMap
              assignment={beat.assignment}
              assignee={beat.assignee}
            />
          </div>
          <div className="mt-3">
            <AddRemark beatId={beat.id} remark={beat.remark} />
          </div>
        </div>
      </Paper>
      <VisitDetails />
    </SubHeader>
  )
}

export default BeatMonitoringDetails
